module.exports = __webpack_public_path__ + "static/media/55_000057.717cbbdf.jpg";